import React, { useState } from 'react';
import {
  Heading,
  Flex,
  Image,
  Spinner,
  Box,
  Link,
  Tooltip,
} from '@chakra-ui/react';
import Reveal from './Reveal';
import TrackerAppTable from './TrackerAppTable';
import TrackerAppSchema from './TrackerAppSchema';
import { TrackerApp } from '../utils/projectImages';

const TrackerAppContent = () => {
  const [recordLoaded, setRecordLoaded] = useState(false);
  return (
    <Reveal>
      <Heading as="p" size="md" lineHeight={1.4} mr={6} ml={6} mt={2}>
        Description: <br />
        Tracker App is a mobile App that tracks the user's location via GPS and
        record the track where the user is going, like for example, a jogging
        route. This App as a whole utilizes two separate App, a Front-End App to
        display and record the routes from the user, and a Back-End App to
        communicate with the database and handling the requests made from the
        Front-End App. <br />
        <br />
        The Back-End App is responsible for handling these requests:
        <br />
      </Heading>
      <TrackerAppTable />
      <Box mr={6} ml={6} mt={2}>
        <Heading as="p" size="md" lineHeight={1.4}>
          The Back-End App have 3 model schemas which are User's schema, Track's
          schema, and Point's schema. Here are the props of each schema. <br />
        </Heading>
        <TrackerAppSchema />
        <Heading as="p" size="md" lineHeight={1.4}>
          Here's some recording from the Front-End App.
        </Heading>
        <Flex mt={8} mb={8} justify="center">
          <Tooltip label={TrackerApp.title} size="md" placement="right-start">
            <Box
              borderRadius="2xl"
              overflow="hidden"
              borderWidth="4px"
              borderColor="transparent"
              transition=".1s linear"
              _hover={{ borderColor: 'blue.200', transform: 'scale(1.05)' }}
            >
              <Image
                src={TrackerApp.image}
                objectFit="contain"
                width="300px"
                display={recordLoaded ? 'block' : 'none'}
                onLoad={() => setRecordLoaded(true)}
                _hover={{}}
              />
              <Spinner
                display={!recordLoaded ? 'block' : 'none'}
                transition=".1s linear"
                size="xl"
                m={4}
              />
            </Box>
          </Tooltip>
        </Flex>
        <Heading as="p" size="md" lineHeight={1.4}>
          If you're wondering why it only shows a straight line on the Track
          Details, it's because I used a mock/fake location that changes every
          second when the App is recording the route. Aand, I'm too lazy to go
          outside to test the App. 😅
          <br />
          <br />
          If you interested more in this project, go ahead and open these links
          below.
          <br />
          <Link
            isExternal
            href="https://github.com/reinaldousadani/tracks-server-code"
            color="orange.500"
          >
            Link to Back-End App Github.
          </Link>
          <br />
          <Link
            isExternal
            href="https://github.com/reinaldousadani/tracks-app"
            color="orange.500"
          >
            Link to Front-End App Github.
          </Link>
          <br />
          <br />
          Technology Used:{' '}
          <Link isExternal href="https://reactnative.dev/" color="orange.500">
            React-Native
          </Link>
          ,{' '}
          <Link isExternal href="https://nodejs.org/en/" color="orange.500">
            NodeJS
          </Link>
          ,{' '}
          <Link isExternal href="https://expressjs.com/" color="orange.500">
            ExpressJS
          </Link>
          ,{' '}
          <Link isExternal href="https://www.mongodb.com/" color="orange.500">
            MongoDB
          </Link>
          {' & '}
          <Link isExternal href="https://expo.io" color="orange.500">
            Expo
          </Link>
          <br />
          Credits to{' '}
          <Link
            isExternal
            href="https://www.udemy.com/user/sgslo/"
            color="orange.500"
          >
            Stephen Grider
          </Link>{' '}
          on Udemy for guiding me through this project.
        </Heading>
      </Box>
    </Reveal>
  );
};

export default TrackerAppContent;
